var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "youtubevideo-container", attrs: { id: _vm.youTubeId } },
    [_c("div", { staticClass: "YouTubeVideo", attrs: { id: _vm.playerId } })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }